import React from 'react';
import { Container, Row, Col, Button, Modal, Form } from 'react-bootstrap';
import TopNavBar from '../Components/TopNavBar';
import ContentBlock from '../Components/ContentBlock';
import Footer from '../Components/Footer';
import KursaiService from '../Api/KursaiService';
import { useParams } from 'react-router-dom';
import { addToCart } from '../Session/Session';


function withRouter(Component) {
    function ComponentWithRouter(props) {
        let params = useParams()
        return <Component {...props} params={params} />
    }
    return ComponentWithRouter
}
class KursasPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            price: '5',
            image: '',
            level: '',
            duration: '',
            description: '',
            dishes: [],
            utencils: []
        };
        this.addItemToCart = this.addItemToCart.bind(this);
    }

    componentDidMount() {

        // console.log(this.props.params.id);

        KursaiService.getKursas(this.props.params.id).then((response) => {
            var image = response.data.Files[0]?.Path ?? '';
            this.setState({
                name: response.data.Name,
                price: response.data.Price,
                image: image,
                level: response.data.Level,
                duration: response.data.Duration,
                description: response.data.Description,
                dishes: response.data.Dishes ?? [],
                utencils: response.data.Utensils ?? [],
                files: response.data.Files,
                showModal: false
            });
        });
    }

    addItemToCart = (event) => {
        console.log('addItemToCart');
        event.preventDefault();
        const course = {
            id: this.props.params.id,
            name: this.state.name,
            price: this.state.price,
            image: this.state.image,
            files: this.state.files
        };
        addToCart(course);
    }

    render() {

        // const { id } = this.props.match.params;

        const pageStyle = {
            backgroundImage: "url(/kursai-page-background.png)",
            height: '100vh',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        };

        const handleClose = () => this.setState({ showModal: false });
        const handleShow = () => this.setState({ showModal: true });

        return (
            <>
                <Container fluid style={pageStyle}>
                    <TopNavBar activeRoute={2} />
                    <h1 className='page-title'>{this.state.name}</h1>
                    <Container>
                        <ContentBlock>
                            <Row>
                                <Col xs={12} md={6} lg={6}>
                                    <img src={this.state.image} style={{ marginTop: '10%' }} alt={this.state.Name} width={'100%'}></img>
                                </Col>
                                <Col xs={12} md={6} lg={6}>
                                    <div className='course-description-block'>
                                        <h2 className='center-text'>{this.state.name}</h2>
                                        <div>Tema: {this.state.name}</div>
                                        <div>Sunkumo lygis: {this.state.level}</div>
                                        <div>Trukmė: {this.state.duration}</div>
                                        <div>Kaina: {this.state.price}</div>
                                        <div>{this.state.description}</div>
                                        <div>Gaminamų patiekalų sąrašas:
                                            <ul>{this.state.dishes.map((dish, index) => <li key={index}>{dish}</li>)}</ul>
                                        </div>
                                        <div>Gera nuotaika - tai viskas, ką reikėtų turėti atvykstant pas mus, visu kitu - pasirūpinsime mes:
                                            <ul>{this.state.utencils.map((utencil, index) => <li key={index}>{utencil}</li>)}</ul>
                                        </div>
                                        <div><Button className='to-cart-button' variant="outline-light" onClick={this.addItemToCart}>Į krepšelį</Button></div>
                                    </div>
                                    <Button variant="outline-light" className='mt-2' onClick={handleShow}>Palikti atsiliepimą</Button>
                                </Col>
                            </Row>
                        </ContentBlock>
                    </Container>
                    <Footer></Footer>
                </Container>
                <Modal show={this.state.showModal} onHide={handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='center-text'>
                            <h3>Palikite atsiliepimą</h3>
                            <div className='rating'>
                                <input type="radio" id="star5" name="rating" value="5" /><label htmlFor="star5" title="5 stars"></label>
                                <input type="radio" id="star4" name="rating" value="4" /><label htmlFor="star4" title="4 stars"></label>
                                <input type="radio" id="star3" name="rating" value="3" /><label htmlFor="star3" title="3 stars"></label>
                                <input type="radio" id="star2" name="rating" value="2" /><label htmlFor="star2" title="2 stars"></label>
                                <input type="radio" id="star1" name="rating" value="1" /><label htmlFor="star1" title="1 star"></label>
                            </div>
                            <div className='mt-2'>
                                <Form.Control as="textarea" rows={3} />
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={handleClose}>
                            Uždaryti
                        </Button>
                        <Button variant="outline-primary" onClick={handleClose}>
                            Išsaugoti
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default withRouter(KursasPage);
